// AppointmentCommunicationsSection.js - Sektion "Skickat" i bokningsrutan (Spår L).
// Hopfällbar lista över allt som skickats för just denna bokning.

import React, { useState, useEffect } from 'react';
import CommunicationList from './CommunicationList';
import { getAppointmentCommunications } from './communicationsApi';
import { getOccurrence, isVirtualOccurrence, occurrenceDateOf } from '../Calendar/calendarApi';

// Vilken bokning gäller utskicken? Ett virtuellt tillfälle i en serie (Spår R)
// delar seriens appointment_id men har inga egna utskick förrän det
// materialiserats. Kalenderns state kan vara inaktuellt (t.ex. efter en
// kallelse som materialiserade tillfället), så slå upp tillfället read-only:
// finns ett riktigt barn → dess id, annars null (= inget skickat).
const resolveAppointmentId = async (appointment) => {
  if (!isVirtualOccurrence(appointment)) return appointment.appointment_id;
  const seriesId = appointment.original_appointment_id || appointment.appointment_id;
  const occ = await getOccurrence(seriesId, occurrenceDateOf(appointment));
  return occ && !isVirtualOccurrence(occ) ? occ.appointment_id : null;
};

const AppointmentCommunicationsSection = ({ appointment }) => {
  const [items, setItems] = useState(null); // null = laddar
  const [error, setError] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const key = isVirtualOccurrence(appointment)
    ? `${appointment.original_appointment_id || appointment.appointment_id}@${occurrenceDateOf(appointment)}`
    : String(appointment.appointment_id);

  useEffect(() => {
    let cancelled = false;
    setItems(null);
    setError(false);
    resolveAppointmentId(appointment)
      .then(id => (id ? getAppointmentCommunications(id) : []))
      .then(data => { if (!cancelled) setItems(data); })
      .catch(err => {
        console.error('Error loading appointment communications:', err);
        if (!cancelled) { setError(true); setItems([]); }
      });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  const count = items ? items.length : null;

  return (
    <div className="form-group appointment-comm-section" style={{ marginBottom: '15px' }}>
      <button
        type="button"
        onClick={() => setExpanded(e => !e)}
        aria-expanded={expanded}
        style={{
          display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
          padding: '6px 0', background: 'none', border: 'none', cursor: 'pointer',
          font: 'inherit', fontWeight: 600, color: '#374151', textAlign: 'left',
        }}
      >
        <i className={`fas fa-chevron-${expanded ? 'down' : 'right'}`} style={{ fontSize: '11px', color: '#9ca3af' }}></i>
        <i className="fas fa-paper-plane" style={{ color: '#6b7280' }}></i>
        Skickat
        <span style={{ fontWeight: 400, color: '#6b7280' }}>
          {count === null ? '…' : `(${count})`}
        </span>
      </button>
      {expanded && (
        error
          ? <div className="comm-empty">Kunde inte hämta utskick</div>
          : items === null
            ? <div className="comm-empty"><i className="fas fa-spinner fa-spin"></i> Laddar...</div>
            : <CommunicationList items={items} compact emptyText="Inget skickat för denna bokning" />
      )}
    </div>
  );
};

export default AppointmentCommunicationsSection;
